import { createTheme } from "@mui/material/styles";

// Hybrid theme: light main content, dark sidebar.
// Two distinctive type families: Outfit (display) and JetBrains Mono (technical accents).
// Color system: warm-neutral light surface, deep ink sidebar, single coral accent.

export const colors = {
    // Light surface (main content area)
    bg: "#FAFAF7",
    surface: "#FFFFFF",
    surfaceAlt: "#F4F2EC",
    border: "#E5E2DA",
    text: "#1A1A1F",
    textMuted: "#6B6B7A",

    // Dark surface (sidebar)
    sidebarBg: "#13131A",
    sidebarSurface: "#1C1C26",
    sidebarBorder: "#2A2A38",
    sidebarText: "#E8E8EE",
    sidebarMuted: "#8A8A9E",

    // Single accent — coral. No purple-gradient cliche.
    accent: "#FF5A4E",
    accentDark: "#E54237",
    accentSoft: "#FFE8E5",

    // Semantic
    success: "#0F9D58",
    warning: "#F59E0B",
    error: "#DC2626",
    info: "#2563EB",
};

export const theme = createTheme({
    palette: {
        mode: "light",
        primary: { main: colors.accent, dark: colors.accentDark, contrastText: "#fff" },
        background: { default: colors.bg, paper: colors.surface },
        text: { primary: colors.text, secondary: colors.textMuted },
        divider: colors.border,
        success: { main: colors.success },
        warning: { main: colors.warning },
        error: { main: colors.error },
        info: { main: colors.info },
    },
    typography: {
        fontFamily: '"Outfit", "Helvetica", "Arial", sans-serif',
        h1: { fontFamily: '"Outfit"', fontWeight: 700, letterSpacing: "-0.02em" },
        h2: { fontFamily: '"Outfit"', fontWeight: 700, letterSpacing: "-0.02em" },
        h3: { fontFamily: '"Outfit"', fontWeight: 600, letterSpacing: "-0.015em" },
        h4: { fontFamily: '"Outfit"', fontWeight: 600, letterSpacing: "-0.01em" },
        h5: { fontFamily: '"Outfit"', fontWeight: 600 },
        h6: { fontFamily: '"Outfit"', fontWeight: 600 },
        button: { fontWeight: 600, textTransform: "none", letterSpacing: "0.01em" },
        overline: {
            fontFamily: '"JetBrains Mono", monospace',
            fontWeight: 500,
            letterSpacing: "0.12em",
            fontSize: "0.7rem",
        },
        caption: { fontFamily: '"JetBrains Mono", monospace', fontSize: "0.72rem" },
    },
    shape: { borderRadius: 10 },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 8,
                    padding: "10px 20px",
                    boxShadow: "none",
                    "&:hover": { boxShadow: "none" },
                },
                containedPrimary: {
                    background: colors.accent,
                    "&:hover": { background: colors.accentDark },
                },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    borderRadius: 14,
                    border: `1px solid ${colors.border}`,
                    boxShadow: "0 1px 2px rgba(20,20,30,0.04)",
                },
            },
        },
        MuiPaper: { styleOverrides: { rounded: { borderRadius: 14 } } },
        MuiTextField: {
            defaultProps: { variant: "outlined", size: "small" },
        },
    },
});
